import FirebaseAdapter from "@wc/adapters/firebase";

/**
 * Updates the current user's display name
 * @param {string} userId The user to update
 * @param {string} newDisplayName The new display name
 * @returns {Promise<void>} Nothing
 * @throws {Error} If display name is invalid
 */
export async function updateDisplayName(userId, newDisplayName) {
  const trimmedName = newDisplayName?.trim();

  if (!trimmedName) {
    throw new Error("Display name cannot be empty");
  }

  if (trimmedName.length > 100) {
    throw new Error("Display name cannot exceed 100 characters");
  }

  await FirebaseAdapter().users.updateUserProfile(userId, {
    displayName: trimmedName,
  });
}
